export const environment = {
  domain: "https://api.clsedo.com/api",
  serverName: "TULA",
  firebaseDomain: "https://us-central1-deknerd-556e6.cloudfunctions.net",
  examReaderDomain: "https://exam-reader.nerdof.com/#/exam",
  examReaderHomeDomain: "https://exam-reader.nerdof.com/#/home",
  // examReaderHomeDomain: "http://localhost:8082/#/home",
  assessmentDomain: "https://evaluate.nerdof.com"
}